import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from "vuex-persistedstate"; //npm install vuex-persistedstate --save

Vue.use(Vuex)

const store = new Vuex.Store({
	plugins: [createPersistedState()],
	state: {
		menus: null,
		sideBar: null,
		sideActiveIndex: null,
		userInfo: null
	},
	mutations: {
		setUserInfo(state, user) {
			state.userInfo = user;
		},
		setMenus(state,menu){
			state.menus = menu;
		},
		setSidebar(state,menu){
			state.sideBar = menu;
		},
		setSidebarIndex(state,path){
			state.sideActiveIndex = path;
		}
	}
})

export default store
